var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshiIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6759 10.8539C15.2847 10.6781 14.8293 10.8618 14.6585 11.2641C13.5887 13.7828 11.1714 15.4102 8.50012 15.4102C6.38257 15.4102 4.42493 14.3863 3.17122 12.7073L5.8103 13.2473C6.22891 13.333 6.63561 13.0533 6.71891 12.6227C6.80216 12.1921 6.53032 11.7736 6.11176 11.688L1.78435 10.8025C1.3658 10.717 0.959043 10.9965 0.875744 11.4271L0.0149916 15.8789C-0.0682555 16.3095 0.203586 16.728 0.622139 16.8136C0.673036 16.824 0.723726 16.829 0.773695 16.829C1.13481 16.829 1.4576 16.5673 1.53075 16.189L2.002 13.7517C3.54599 15.772 5.9275 17.0001 8.50012 17.0001C11.7857 17.0001 14.7589 14.9984 16.0746 11.9006C16.2455 11.4984 16.067 11.0297 15.6759 10.8539Z",
    fill: "#DED4DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3775 0.185961C15.959 0.100426 15.5522 0.379976 15.4689 0.810564L14.9976 3.24819C13.4536 1.22801 11.0721 0 8.49975 0C5.21422 0 2.24102 2.00169 0.925191 5.09942C0.754318 5.50171 0.932815 5.97035 1.32386 6.14613C1.42462 6.19139 1.52956 6.21285 1.63289 6.21285C1.9307 6.21285 2.21449 6.03468 2.34137 5.736C3.41122 3.21729 5.82853 1.58981 8.4998 1.58981C10.617 1.58981 12.5746 2.61346 13.8283 4.2923L11.1893 3.75223C10.7707 3.66664 10.364 3.94619 10.2807 4.37678C10.1974 4.80736 10.4692 5.22587 10.8878 5.31156L15.2153 6.19717C15.2653 6.2074 15.3158 6.21243 15.366 6.21243C15.5178 6.21243 15.6674 6.16643 15.7953 6.07846C15.9657 5.96134 16.0839 5.77935 16.1239 5.57256L16.9846 1.12064C17.0679 0.690105 16.7961 0.271601 16.3775 0.185961Z",
    fill: "#DED4DF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshiIconGrey);
export default __webpack_public_path__ + "static/media/refreshi-icon-grey.c0a71437ec450a782cd6dcf7e4bbfefe.svg";
export { ForwardRef as ReactComponent };